import React from "react";

import Alerter from "../../../Components/Common/Alerter";
import {useCookie} from "../../../hooks/useCookie";
import NotificationModal from "../../../Components/Common/NotificationModal";


const NotificationDetailsContainer = (
    {
        productId,
        showNotification,
        notificationText,
    }) => {
    const [hasSeenNotification, setHasSeenNotification] = useCookie(
        `notification_seen_${productId}`,
        !Boolean(Number(showNotification) === 1)
    );
    const [showModal, setShowModal] = React.useState(showNotification);

    const handleModalToggle = () => {
        if (showModal && !hasSeenNotification) {
            setHasSeenNotification('true', {expires: 30});
        }
        setShowModal(!showModal);
    };

    if (hasSeenNotification) {
        return null;
    }

    return (
        <Alerter
            cancelText="Sluit melding"
            onCancel={handleModalToggle}>

            <NotificationModal
                notification={{text: notificationText}}
                onCancel={handleModalToggle}
            />
        </Alerter>
    )
}

export default NotificationDetailsContainer;